<template>
  <tr v-if="isRejected">
    <td colspan="2" />
    <td class="no-wrap">
      <span style="color: gray">却下理由</span>
    </td>
    <td colspan="6">
      {{ rejectReason }}
    </td>
  </tr>
</template>

<script>
import { MapReportStatuses } from '@/models/MapReport'

export default {
  name: 'AdminMapReportListRejectReason',
  props: {
    status: {
      type: String,
      default: '',
    },
    rejectReason: {
      type: String,
      default: '',
    },
  },
  computed: {
    isRejected() {
      return this.status === MapReportStatuses.Rejected
    },
  },
}
</script>

<style scoped></style>
